<script setup>
import { onMounted, onUnmounted, reactive, computed, ref } from "vue";
import { salesListsApi } from "@/api/forsales_index";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { regenerationRequest } from "@/store/modules/regenerationSalesListsDetail";
import LoadingIcon from "@/components/LoadingIcon.vue";
import { Modal } from 'bootstrap';
import { datePipe } from "@/utils/datatimeUtils";

const router = useRouter();
const route = useRoute();
const pageMaxCount = 100;
const { locale } = useI18n();
const raw_data = ref([]);
const editedRowId = ref(null);
const sales_list_id = route.params.sales_list_id;
const data = reactive({
  items: [],
  checked_items: {},
  filtered_Key: {
    sales_list_id: sales_list_id,
    search_Key: null,
    target_flag: null,
    crawl_status: null,
    generate_status: null,
    check_status: null,
    send_status: null,
  }
});
const filterKey = reactive({
  searchKey: null,
});
const searchKey = ref("");
const pageList = ref([]);
const pageIndex = ref(0);
const selectedPage = ref(1);
const isLoading = ref(false);
const isStatusRefreshing = ref(false);
const id_for_delete = ref(-1);
const title_for_delete = ref("");
let lastPage = 0;
let statusPollingTimer = null;
let statusPollingAttempts = 0;
const STATUS_POLL_INTERVAL_MS = 3000;
const STATUS_POLL_MAX_ATTEMPTS = 40;
const salesListDetailId = ref(0);
const detai_item = reactive({
  company_name: "",
  person_name: "",
  company_url: "",
  email: "",
  company_detail: "",
  mail_text: "",

  crawl_status: 0,
  generate_status: 0,
  check_status: false,
  send_status: 0,
});
const all_select_flg = ref(false);
const bulkDeleteIds = ref([]);
const showBulkDeleteModal = ref(false);

const data_count = computed(() => { 
  // 現在のタブ状態に応じてフィルタリングされたデータの件数を返す
  const filteredData = getFilteredDataByTab();
  return filteredData.length;
});

const selected_count = computed(() => {
  return Object.values(data.checked_items).filter(Boolean).length;
});

const showPaging = computed(() => {
  if (data.items.length > 0) {
    return true;
  } else {
    return false;
  }
});

const activePageList = computed(() => { return pageList.value[pageIndex.value] });

const crawl_val = [
  "SalesListsDetailsView.process_pending",
  "SalesListsDetailsView.processing",
  "SalesListsDetailsView.finish",
  "SalesListsDetailsView.process_fail",
]

const generate_val = [
  "SalesListsDetailsView.generate_pending",
  "SalesListsDetailsView.generating",
  "SalesListsDetailsView.finish",
  "SalesListsDetailsView.generate_fail",
]

const check_val = [
  "SalesListsDetailsView.uncheck",
  "SalesListsDetailsView.checked",
]

const send_val = [
  "SalesListsDetailsView.send_none",
  "SalesListsDetailsView.send_pending",
  "SalesListsDetailsView.send_processing",
  "SalesListsDetailsView.send_finish",
  "SalesListsDetailsView.send_fail",
  "SalesListsDetailsView.send_delivered",
  "SalesListsDetailsView.send_open",
  "SalesListsDetailsView.send_click",
]

const activeTab = ref('all');

let editModalInst = null;

// hook for life(生命周期钩子)
onMounted(async () => {
  try {
    const optionResp = await salesListsApi.check_optionAccess();
    console.log(optionResp)
    if (optionResp.message !== "ok") {
      return router.push(`/forsales/options_error`);
    }
  }
  catch (error) {
    return router.push(`/forsales/options_error`);
  }

  // モーダルインスタンスを1回だけ作成
  const el = document.getElementById('editSalesListsDetails');
  if (el) {
    editModalInst = new Modal(el, { backdrop: 'static', keyboard: false });
  }

  await getAllData();

  window.addEventListener('keydown', handleKey);
});

onUnmounted(() => {
  stopStatusPolling();
  window.removeEventListener('keydown', handleKey);
});

const handleKey = (e) => {
  if (e.key === 'Escape') { // 或 e.key === 'Esc'
    // console.log( "editModalInst:", editModalInst)
    if (editModalInst._isShown)
    {
      console.log("全局 Esc 被触发");
      hideModal('editSalesListsDetails')
    }
  }
};

const hasProcessingItems = (items = raw_data.value) => {
  return items.some((item) =>
    item.crawl_status === 1 || item.generate_status === 1 || item.send_status === 2
  );
};

const stopStatusPolling = () => {
  if (statusPollingTimer) {
    window.clearInterval(statusPollingTimer);
    statusPollingTimer = null;
  }
  statusPollingAttempts = 0;
};

const startStatusPolling = () => {
  if (statusPollingTimer || !hasProcessingItems()) {
    return;
  }

  statusPollingAttempts = 0;
  statusPollingTimer = window.setInterval(async () => {
    if (isStatusRefreshing.value) {
      return;
    }

    isStatusRefreshing.value = true;
    statusPollingAttempts += 1;

    try {
      await refreshData({ showLoader: false });
      if (!hasProcessingItems() || statusPollingAttempts >= STATUS_POLL_MAX_ATTEMPTS) {
        stopStatusPolling();
      }
    } catch (error) {
      console.error('status polling error:', error);
      if (statusPollingAttempts >= STATUS_POLL_MAX_ATTEMPTS) {
        stopStatusPolling();
      }
    } finally {
      isStatusRefreshing.value = false;
    }
  }, STATUS_POLL_INTERVAL_MS);
};

const getAllData = async () => {
  console.log("sales_list_id:", sales_list_id)
  const resp = await salesListsApi.getAllDetailsFilter(sales_list_id);
  raw_data.value = resp.data;
  data.items = getPageData(resp.data, true);
  console.log("data.items:", data.items)
  raw_data.value.map((item) => {
    data.checked_items[item.id] = false;
  });
  console.log("checked_items:", data.checked_items)

  pageList.value = await salesListsApi.getSalesDetailPage(sales_list_id);
  getLastPage();

  if (hasProcessingItems(resp.data)) {
    startStatusPolling();
  } else {
    stopStatusPolling();
  }
}

const handleFilter = async () => {
  activeTab.value = 'all'; // タブ状態をリセット
  isLoading.value = true;
  setFirstPage();
  filterKey.searchKey = searchKey.value;

  // 検索キーが全部NULLの場合はデータは変更しない
  let is_key_null = checke_filter_key_null();
  if (is_key_null) {
    getAllData();
    return
  }

  // 検索キーでデータの取得
  raw_data.value = await salesListsApi.getDetailsFilterByKey(data.filtered_Key);
  data.items = getPageData(raw_data.value, false);
  data.checked_items = {};
  raw_data.value.map((item) => { data.checked_items[item.id] = false; });
  isLoading.value = false;
};

const handleCreate = async () => {
  console.log("handleCreate()...")
  console.log("sales_list_id:", sales_list_id)
  await router.push(`/forsales/sales_lists/${sales_list_id}/sales_lists_details/new`);
};

const handleGenerate = async () => {
  isLoading.value = true;
  try {
    console.log("handle_generate()...")
    console.log("checked_items:", data.checked_items)
    console.log("currentRoute:", router.currentRoute.value)
    const items = raw_data.value;
    for (const i in items) {
      const detail_id = items[i].id
      if (data.checked_items[detail_id]) {
        const company_url = items[i].company_url
        const company_name = items[i].company_name
        console.log("** ", i, detail_id, company_name, company_url)
        await updateTargetFlag(detail_id, true, company_url)
      }
    }
    isLoading.value = false;
    refreshData();
  } catch (err) {
    console.error('refreshData error', err);
    // トーストでもアラートでも好きに通知
  } finally {
    isLoading.value = false;   // ← 絶対に戻す
  }
}

const handleSendMail = async () => {
  console.log("handle_send_mail()...")
  console.log("sales_list_id:", sales_list_id)
  const resp = await salesListsApi.getList_1(sales_list_id)
  const sales_list = resp.data
  const sender_mail_address = sales_list.sender_mail_address
  const mail_title = sales_list.mail_title

  isLoading.value = true

  const detail = raw_data.value;
  for (const i in detail) {
    const detail_id = detail[i].id
    if (data.checked_items[detail_id]) {
      const check_status = detail[i].check_status
      if (check_status !== 1)
        continue

      // const crawl_status = detail[i].crawl_status
      // if (crawl_status == 1 || crawl_status == 0)
      //   continue

      // const generate_status = detail[i].generate_status
      // if (generate_status == 1 || generate_status == 0)
      //   continue

      const send_status = detail[i].send_status
      if (send_status === 0) {
        // update send_status to 2
        let _dict = {
          sales_lists_detail_id: detail_id,
          send_status: 2,
        }
        let resp_update = await salesListsApi.updateSaleslist_detail(_dict);
        console.log("** resp_update:", resp_update)
        if (resp_update.status !== 200) {
          throw new Error("update send_status to 1 ERROR");
        }

        // try to send mail
        const email = detail[i].email
        const mail_text = detail[i].mail_text


        // send mail
        const formData = new FormData()
        // formData.append( "detail_id", id);
        formData.append("sender_mail_address", sender_mail_address);
        formData.append("mail_title", mail_title);
        formData.append("email", email);
        formData.append("mail_text", mail_text);
        formData.append("sales_list_id", sales_list_id);
        console.log("formData:", formData)

        const rsp = await salesListsApi.send_mail(detail_id, formData);
        if (rsp.status !== 200) {
          throw new Error("ERROR");
        }

      }

    }
  }
  isLoading.value = false

  await refreshData();
  startStatusPolling();

  // 顯示警告對話框
  let btn = document.getElementById("send_mail_finished");
  btn.click();

};

const onSelectAllChange = () => {
  for (const item of data.items) {
    const id = item.id;
    data.checked_items[id] = all_select_flg.value;
  }
  console.log("checked_items:", data.checked_items)
}

const onSelectChange = async (e) => {
  console.log(e.target.value, e.target.checked)
  console.log(data.checked_items)
};

const updateTargetFlag = async (detail_id, target_flag, company_url) => {
  console.log("update_target_flag:", detail_id, target_flag)
  if (target_flag) {
    // 対象のアイテムからcompany_nameを取得
    const targetItem = raw_data.value.find(item => item.id === detail_id);
    const company_name = targetItem ? targetItem.company_name : '';
    
    // call api
    const formData = new FormData()
    formData.append("target_flag", target_flag)
    formData.append("locale", locale.value)
    formData.append("company_url", company_url)
    formData.append("company_name", company_name)
    
    const resp = await salesListsApi.update_target_flag(detail_id, formData)
    if (resp.status !== 200) {
      throw new Error("salesListsApi.update_target_flag() ERROR");
    }
    console.log("update_target_flag.resp:", resp)
  }
}

const handleEdit = async (detailId) => {
  editedRowId.value = detailId;

  console.log("** handleEdit:salesListDetailId:", detailId);

  salesListDetailId.value = detailId;

  const resp = await salesListsApi.getDetails_1(detailId);
  detai_item.company_name = resp.data.company_name;
  detai_item.person_name = resp.data.person_name;
  detai_item.company_url = resp.data.company_url;
  detai_item.email = resp.data.email;
  detai_item.company_detail = resp.data.company_detail;
  detai_item.mail_text = resp.data.mail_text;
  detai_item.crawl_status = resp.data.crawl_status;
  detai_item.generate_status = resp.data.generate_status;
  detai_item.check_status = Boolean(resp.data.check_status);
  detai_item.send_status = resp.data.send_status
};

const openEditModal = async (detailId) => {
  await handleEdit(detailId);      // データを設定
  if (editModalInst) {
    editModalInst.show();          // モーダルを表示
  }
};

const openDeleteModal = (item) => {
  id_for_delete.value = item.id;
  title_for_delete.value = item.company_name;
};

const handleDelete = async () => {
  isLoading.value = true;

  const resp = await salesListsApi.deleteSalesListDetail(
    id_for_delete.value, { sales_list_id: sales_list_id });
  if (resp.status !== 200) {
    isLoading.value = false;
    throw new Error("ERROR");
  }
  data.items = data.items.filter((item) => item.id !== id_for_delete.value);
  isLoading.value = false;
};

const refreshData = async ({ showLoader = true } = {}) => {
  try {
    if (showLoader) {
      isLoading.value = true;
    }
    
    // データを再取得
    // _ts: avoid any intermediate caching and force latest statuses
    const response = await salesListsApi.getAllDetailsFilter(sales_list_id, { _ts: Date.now() });

    // Preserve checkbox selection by id (best effort)
    const prevChecked = { ...data.checked_items };

    raw_data.value = response.data;

    // Rebuild checked_items to keep Vue reactivity stable
    data.checked_items = {};
    for (const item of raw_data.value) {
      data.checked_items[item.id] = Boolean(prevChecked[item.id]);
    }

    // Re-apply current tab filter and update the visible page slice
    const filteredData = getFilteredDataByTab();
    data.items = getPageData(filteredData, false);
    
    if (hasProcessingItems(response.data)) {
      startStatusPolling();
    } else {
      stopStatusPolling();
    }

    console.log('データが正常に更新されました');
    
  } catch (error) {
    console.error('データ更新エラー:', error);
  } finally {
    if (showLoader) {
      isLoading.value = false;
    }
  }
};

const setSelectedPage = (page) => {
  all_select_flg.value = false;
  selectedPage.value = page;
  
  // 現在のタブ状態に応じてフィルタリングされたデータを使用
  let filteredData = getFilteredDataByTab();
  data.items = getPageData(filteredData, false);
}

const setFirstPage = () => {
  all_select_flg.value = false;
  selectedPage.value = 1;
  pageIndex.value = 0;
  
  // 現在のタブ状態に応じてフィルタリングされたデータを使用
  let filteredData = getFilteredDataByTab();
  data.items = getPageData(filteredData, false);
}

const setLastPage = () => {
  all_select_flg.value = false;
  selectedPage.value = lastPage;
  pageIndex.value = pageList.value.length - 1;
  
  // 現在のタブ状態に応じてフィルタリングされたデータを使用
  let filteredData = getFilteredDataByTab();
  data.items = getPageData(filteredData, false);
}

const nextPage = () => {
  // 最後のページは何もしない
  if (selectedPage.value == lastPage) {
    return;
  }
  all_select_flg.value = false;
  selectedPage.value += 1;
  if (!(activePageList.value.includes(selectedPage.value))) {
    pageIndex.value += 1;
  }

  // 現在のタブ状態に応じてフィルタリングされたデータを使用
  let filteredData = getFilteredDataByTab();
  data.items = getPageData(filteredData, false);
}

const previousPage = () => {
  // 最初のページは何もしない
  if (selectedPage.value == 1) {
    return;
  }
  all_select_flg.value = false;
  selectedPage.value -= 1;
  if (!(activePageList.value.includes(selectedPage.value))) {
    pageIndex.value -= 1;
  }

  // 現在のタブ状態に応じてフィルタリングされたデータを使用
  let filteredData = getFilteredDataByTab();
  data.items = getPageData(filteredData, false);
}

const makePageList = (totalPages) => {
  const array = Array.from({ length: totalPages }, (v, i) => i + 1);
  const groupSize = 6;
  const result = [];

  for (let i = 0; i < array.length; i += groupSize) {
    result.push(array.slice(i, i + groupSize));
  }
  pageList.value = result;
}

const getLastPage = () => {
  if (pageList.value.length != 0) {
    let lastIndex = pageList.value[pageList.value.length - 1];
    lastPage = lastIndex[lastIndex.length - 1];
  }
}

const regeneration = async () => {
  const regeneration_request = new regenerationRequest(sales_list_id, locale.value);
  const items = raw_data.value;
  for (const i in items) {
    const detail_id = items[i].id;
    if (data.checked_items[detail_id]) {
      regeneration_request.sales_list_detail_ids.push(detail_id)
    }
  }
  await salesListsApi.regenerationSalesListsDetail(regeneration_request);
  refreshData();

}

const hideModal = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  Modal.getOrCreateInstance(el).hide();
};

const updateData = async () => {
  try {
    const _dict = {
      sales_lists_detail_id: salesListDetailId.value,
      company_name: detai_item.company_name,
      person_name: detai_item.person_name,
      company_url: detai_item.company_url,
      email: detai_item.email,
      company_detail: detai_item.company_detail,
      mail_text: detai_item.mail_text,
      check_status: Number(detai_item.check_status),
    }

    isLoading.value = true;
    await salesListsApi.updateSaleslist_detail(_dict);
    
    // データを更新
    data.items = data.items.map((item) => {
      if (item.id == salesListDetailId.value) {
        item.check_status = Number(detai_item.check_status);
      }
      return item
    });

    // モーダルを閉じる
    hideModal('editSalesListsDetails');
    
    // データを再取得（タブ状態を保持）
    await refreshData();

  } catch (error) {
    console.error('更新エラー:', error);
    alert('更新に失敗しました');
  } finally {
    isLoading.value = false;
  }
}

const checke_filter_key_null = () => {
  if (data.filtered_Key.check_status === null &&
    data.filtered_Key.crawl_status === null &&
    data.filtered_Key.generate_status === null &&
    data.filtered_Key.search_Key === null &&
    data.filtered_Key.send_status === null &&
    data.filtered_Key.target_flag === null
  ) {
    return true
  }

  return false
}

const getPageData = (filteredData, is_onMounted) => {
  if (!is_onMounted) {
    // ページ変数を更新する（フィルタリングされたデータの長さを使用）
    const totalPages = Math.ceil(filteredData.length / pageMaxCount);
    makePageList(totalPages);
    getLastPage();
    
    // 現在のページが総ページ数を超えている場合は最初のページに戻す
    if (selectedPage.value > totalPages && totalPages > 0) {
      selectedPage.value = 1;
      pageIndex.value = 0;
    }
  }

  let start = (selectedPage.value - 1) * pageMaxCount;
  let end = selectedPage.value * pageMaxCount;
  return filteredData.slice(start, end);
}

const handleConfirmAndSend = async () => {
  try {
    isLoading.value = true;
    
    // まず更新処理を実行
    const _dict = {
      sales_lists_detail_id: salesListDetailId.value,
      company_name: detai_item.company_name,
      person_name: detai_item.person_name,
      company_url: detai_item.company_url,
      email: detai_item.email,
      company_detail: detai_item.company_detail,
      mail_text: detai_item.mail_text,
      check_status: Number(detai_item.check_status),
    }
    await salesListsApi.updateSaleslist_detail(_dict);
    
    // 送信リストの情報を取得
    const resp = await salesListsApi.getList_1(sales_list_id);
    const sales_list = resp.data;
    const sender_mail_address = sales_list.sender_mail_address;
    const mail_title = sales_list.mail_title;
    
    // 確認済みステータスに更新
    const updateDict = {
      sales_lists_detail_id: salesListDetailId.value,
      check_status: 1,
    };
    await salesListsApi.updateSaleslist_detail(updateDict);
    
    // send_statusを2（送信中）に更新
    const sendStatusDict = {
      sales_lists_detail_id: salesListDetailId.value,
      send_status: 2,
    };
    await salesListsApi.updateSaleslist_detail(sendStatusDict);
    
    // メール送信用のformDataを作成
    const formData = new FormData();
    formData.append("sender_mail_address", sender_mail_address);
    formData.append("mail_title", mail_title);
    formData.append("email", detai_item.email);
    formData.append("mail_text", detai_item.mail_text);
    formData.append("sales_list_id", sales_list_id);
    
    // メール送信
    const response = await salesListsApi.send_mail(salesListDetailId.value, formData);
    
    if (response.status === 200) {
      // API は queue 登録完了を返すため、ここでは送信処理開始として扱う
      alert('メール送信処理を開始しました');
      
      // モーダルを適切に閉じる
      hideModal('editSalesListsDetails');
      
      // データを再取得して表示を更新（タブ状態を保持）
      await refreshData();
      startStatusPolling();
    } else {
      throw new Error('送信に失敗しました');
    }
    
  } catch (error) {
    console.error('確認済み送信エラー:', error);
    alert('メールの送信に失敗しました');
  } finally {
    isLoading.value = false;
  }
};

const setStatusFilter = async (tabType) => {
  activeTab.value = tabType;
  isLoading.value = true;
  
  // フィルターをリセット
  data.filtered_Key.crawl_status = null;
  data.filtered_Key.send_status = null;
  data.filtered_Key.generate_status = null;
  data.filtered_Key.check_status = null;
  
  // ページを最初にリセット
  selectedPage.value = 1;
  pageIndex.value = 0;
  
  let filteredData = getFilteredDataByTab();
  
  data.items = getPageData(filteredData, false);
  data.checked_items = {};
  filteredData.map((item) => { data.checked_items[item.id] = false; });
  
  isLoading.value = false;
};


// 現在のタブ状態に応じてフィルタリングされたデータを取得する関数
const getFilteredDataByTab = () => {
  let filteredData = [];
  
  switch (activeTab.value) {
    case 'before_generation':
      // 生成前: crawl_status = 0
      filteredData = raw_data.value.filter(item => item.crawl_status === 0);
      break;
      
    case 'generated_unconfirmed':
      // 生成完了・未確認: generate_status = 2 and check_status = 0
      filteredData = raw_data.value.filter(item => 
        item.generate_status === 2 && item.check_status === 0
      );
      break;
      
    case 'waiting_send':
      // 送信待ち: generate_status = 2 and send_status = 0 and check_status = 1
      filteredData = raw_data.value.filter(item => 
        item.generate_status === 2 && item.send_status === 0 && item.check_status === 1
      );
      break;
      
    case 'completed':
      // 完了: send_status = 3 or 5 or 6 or 7
      filteredData = raw_data.value.filter(item => 
        item.send_status === 3 || item.send_status === 5 || 
        item.send_status === 6 || item.send_status === 7
      );
      break;
      
    case 'failed':
      // 失敗: send_status = 4
      filteredData = raw_data.value.filter(item => item.send_status === 4 || item.crawl_status === 3 || item.generate_status === 3);
      break;
      
    case 'processing':
      // 処理中: crawl_status = 1 or generate_status = 1 or send_status = 2
      filteredData = raw_data.value.filter(item => 
        item.crawl_status === 1 || item.generate_status === 1 || item.send_status === 2
      );
      break;
      
    case 'all':
    default:
      // すべて
      filteredData = raw_data.value;
      break;
  }
  
  return filteredData;
};

// ステータスに応じたCSSクラスを返す関数群
const getCrawlStatusClass = (status) => {
  switch (status) {
    case 0: return 'status-pending';     // 処理待ち - グレー
    case 1: return 'status-processing';  // 処理中 - 黄色
    case 2: return 'status-completed';   // 完了 - 緑
    case 3: return 'status-failed';      // 失敗 - 赤
    default: return 'status-pending';
  }
};

const getGenerateStatusClass = (status) => {
  switch (status) {
    case 0: return 'status-pending';     // 生成待ち - グレー
    case 1: return 'status-processing';  // 生成中 - 黄色
    case 2: return 'status-completed';   // 完了 - 緑
    case 3: return 'status-failed';      // 失敗 - 赤
    default: return 'status-pending';
  }
};

const getCheckStatusClass = (status) => {
  switch (status) {
    case 0: return 'status-unconfirmed'; // 未確認 - オレンジ
    case 1: return 'status-confirmed';   // 確認済み - 青
    default: return 'status-unconfirmed';
  }
};

const getSendStatusClass = (status) => {
  switch (status) {
    case 0: return 'status-pending';     // 送信なし - グレー
    case 1: return 'status-pending';     // 送信待ち - グレー
    case 2: return 'status-processing';  // 送信中 - 黄色
    case 3: return 'status-completed';   // 送信完了 - 緑
    case 4: return 'status-failed';      // 送信失敗 - 赤
    case 5: return 'status-delivered';   // 配信済み - 濃い緑
    case 6: return 'status-opened';      // 開封済み - 青
    case 7: return 'status-clicked';     // クリック済み - 紫
    default: return 'status-pending';
  }
};

const handleBulkDelete = () => {
  // チェックされたアイテムを取得
  const checkedIds = [];
  for (const [itemId, isChecked] of Object.entries(data.checked_items)) {
    if (isChecked) {
      checkedIds.push(parseInt(itemId));
    }
  }
  
  if (checkedIds.length === 0) {
    alert('削除する項目を選択してください');
    return;
  }
  
  bulkDeleteIds.value = checkedIds;
  showBulkDeleteModal.value = true;
};

const confirmBulkDelete = async () => {
  try {
    isLoading.value = true;
    
    const formData = new FormData();
    formData.append('sales_list_detail_ids', JSON.stringify(bulkDeleteIds.value));
    formData.append('sales_list_id', sales_list_id);
    
    const response = await salesListsApi.bulkDeleteSalesListDetails(formData);
    
    if (response.status === 200) {
      // 削除成功時の処理
      showBulkDeleteModal.value = false;
      
      // チェック状態をリセット
      all_select_flg.value = false;
      data.checked_items = {};
      
      alert(`${bulkDeleteIds.value.length}件のレコードを削除しました`);
      
      // ページを強制リロード（最も確実な方法）
      window.location.reload();
      
    } else {
      throw new Error('削除に失敗しました');
    }
  } catch (error) {
    console.error('一括削除エラー:', error);
    alert('削除に失敗しました');
  } finally {
    isLoading.value = false;
    bulkDeleteIds.value = [];
  }
};

const cancelBulkDelete = () => {
  showBulkDeleteModal.value = false;
  bulkDeleteIds.value = [];
};

</script>

<template>
  <LoadingIcon :is-loading="isLoading"></LoadingIcon>

  <!-- main view -->
  <div class="container">

    <!-- title(標題) -->
    <div class="row">
      <h4>{{ $t("SalesListsDetailsView.h4") }}</h4>
    </div>

    <!-- key for filer(關鍵詞過濾) -->
    <div class="row">
      <div class="column">

        <label for="search-keyword">{{ $t("SalesListsDetailsView.search_keyword") }}</label>
        <input type="text" id="search-keyword" v-model="data.filtered_Key.search_Key"
          style="padding: 0 50px; margin: 10px;" />

        <button class="btn btn-primary" @click="handleFilter" style="padding: 0 50px; margin: 10px;">
          {{ $t("SalesListsDetailsView.handle_filter") }}</button>
      </div>

    </div>

    <!-- 4 combobox(4個下拉選項) -->
    <!-- <div class="row"> -->

      <!-- info of target_flag(生成対象) -->
      <!-- <div class="column">
        <label for="target_flag">{{ $t("SalesListsDetailsView.target_flag") }}</label>
        <select id="target_flag" class="form-select" v-model="data.filtered_Key.target_flag" @change="handleFilter">
          <option :value=null> - </option>
          <option :value=true>ON</option>
          <option :value=false>OFF</option>
        </select>
      </div> -->

      <!-- info of company(獲取公司資訊) -->
      <!-- <div class="column">
        <label for="company_information">
          {{ $t("SalesListsDetailsView.company_information") }}</label>
        <select id="company_information" class="form-select" v-model="data.filtered_Key.crawl_status"
          @change="handleFilter">
          <option :value=null> - </option>
          <option :value=0>{{ $t(crawl_val[0]) }}</option>
          <option :value=1>{{ $t(crawl_val[1]) }}</option>
          <option :value=2>{{ $t(crawl_val[2]) }}</option>
          <option :value=3>{{ $t(crawl_val[3]) }}</option>
        </select>
      </div> -->

      <!-- text generate(文章生成) -->
      <!-- <div class="column">
        <label for="text_generate">
          {{ $t("SalesListsDetailsView.text_generate") }}</label>
        <select id="text_generate" class="form-select" v-model="data.filtered_Key.generate_status"
          @change="handleFilter">
          <option :value=null> - </option>
          <option :value=0>{{ $t(generate_val[0]) }}</option>
          <option :value=1>{{ $t(generate_val[1]) }}</option>
          <option :value=2>{{ $t(generate_val[2]) }}</option>
          <option :value=3>{{ $t(generate_val[3]) }}</option>
        </select>
      </div> -->

      <!-- text confirm(内容確認) -->
      <!-- <div class="column">
        <label for="text_confirm">
          {{ $t("SalesListsDetailsView.text_confirm") }}</label>
        <select id="text_confirm" class="form-select" v-model="data.filtered_Key.check_status" @change="handleFilter">
          <option :value=null> - </option>
          <option :value=0>{{ $t(check_val[0]) }}</option>
          <option :value=1>{{ $t(check_val[1]) }}</option>
        </select>
      </div> -->

      <!-- send mail(發電子郵件) -->
      <!-- <div class="column">
        <label for="send_mail">{{ $t("SalesListsDetailsView.send_mail") }}</label>
        <select id="send_mail" class="form-select" v-model="data.filtered_Key.send_status" @click="handleFilter">
          <option :value=null> - </option>
          <option :value=0>{{ $t(send_val[0]) }}</option>
          <option :value=1>{{ $t(send_val[1]) }}</option>
          <option :value=2>{{ $t(send_val[2]) }}</option>
          <option :value=3>{{ $t(send_val[3]) }}</option>
          <option :value=4>{{ $t(send_val[4]) }}</option>
        </select>
      </div>
    </div> -->

    <!-- 新しく追加するステータスタブ -->
    <div class="row">
      <div class="status-tabs">
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'before_generation' }"
          @click="setStatusFilter('before_generation')"
        >
          {{ $t('SalesListsDetailsView.before_generation') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'generated_unconfirmed' }"
          @click="setStatusFilter('generated_unconfirmed')"
        >
          {{ $t('SalesListsDetailsView.generated_unconfirmed') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'waiting_send' }"
          @click="setStatusFilter('waiting_send')"
        >
          {{ $t('SalesListsDetailsView.waiting_send') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'completed' }"
          @click="setStatusFilter('completed')"
        >
          {{ $t('SalesListsDetailsView.completed') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'failed' }"
          @click="setStatusFilter('failed')"
        >
          {{ $t('SalesListsDetailsView.failed') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'processing' }"
          @click="setStatusFilter('processing')"
        >
          {{ $t('SalesListsDetailsView.processing') }}
        </button>
        <button 
          class="status-tab" 
          :class="{ active: activeTab === 'all' }"
          @click="setStatusFilter('all')"
        >
          {{ $t('SalesListsDetailsView.all') }}
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-between">

      <!-- select/de-select -->
      <div>
        <input class="form-check-input" id="select_all" type="checkbox" v-model="all_select_flg"
          @change="onSelectAllChange" />
        <label style="padding: 0 50px; margin: 1px;" for="select_all">
          {{ $t("SalesListsDetailsView.select_all") }}</label>
      </div>

      <!-- 2 button -->
      <div>

        <button class="btn btn-primary" @click="handleCreate" style="padding: 0 50px; margin: 10px;">
          {{ $t("SalesListsDetailsView.handleCreate") }}</button>

        <button class="btn btn-primary" @click="handleGenerate" style="padding: 0 50px; margin:10px;">
          {{ $t("SalesListsDetailsView.target_flag") }}</button>

        <button class="btn btn-primary" @click="regeneration" style="padding: 0 50px; margin:10px;">
          {{ $t("SalesListsDetailsView.regeneration") }}</button>

        <button class="btn btn-primary" @click="handleSendMail" style="padding: 0 50px; margin: 10px;">
          {{ $t("SalesListsDetailsView.handle_send") }}</button>

        <!-- 一括削除ボタンを追加 -->
        <button class="btn btn-danger" @click="handleBulkDelete" style="padding: 0 50px; margin: 10px;">
          {{ $t("SalesListsDetailsView.bulk_delete") }}</button>

        <button class="btn btn-primary" @click="refreshData" style="padding: 0 50px; margin: 10px;">
          {{ $t("SalesListsDetailsView.refresh") }}
        </button>

      </div>
    </div>

    <!-- データ件数表示 -->
    <div>{{ $t("SalesListsDetailsView.data_count") }}{{ selected_count }}/{{ data_count }}</div>

    <!-- the main table(主體表格) -->
    <div class="row">
      <table class="table table-hover table-sm fixed-table">
        <thead>
          <tr>
            <th scope="col" style="width: 50px;">
              {{ $t("SalesListsDetailsView.selected") }}</th>
            <th scope="col">
              {{ $t("SalesListsDetailsView.company_name") }}</th>
            <th scope="col" style="width: 190px;">
              {{ $t("SalesListsDetailsView.company_url") }}</th>
            <th scope="col" style="width: 90px;">
              {{ $t("SalesListsDetailsView.target") }}</th>
            <th scope="col" style="width: 120px;">
              {{ $t("SalesListsDetailsView.crawl_status") }}</th>
            <th scope="col" style="width: 100px;">
              {{ $t("SalesListsDetailsView.generate_status") }}</th>
            <th scope="col" style="width: 100px;">
              {{ $t("SalesListsDetailsView.check_status") }}</th>
            <th scope="col" style="width: 100px;">
              {{ $t("SalesListsDetailsView.send_status") }}</th>
            <th scope="col" style="width: 150px;">
              {{ $t("SalesListsDetailsView.last_sent_at") }}</th>
            <th scope="col" style="width: 250px; text-align: center;">
              {{ $t("SalesListsDetailsView.operation") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in data.items" :key="item.id" :id="`row-${item.id}`" :class="{ 'table-warning': item.id === editedRowId }">
            <td style="width: 50px;" @click.stop>
              <input class="form-check-input" type="checkbox" v-model="data.checked_items[item.id]"
                @change="onSelectChange">
            </td>
            <td>{{ item.company_name }}</td>
            <td style="width: 190px;">{{ item.company_url }}</td>
            <td style="width: 90px;">
              <label class="switch">
                <input type="checkbox" v-model="item.target_flag" disabled>
                <span class="slider round"></span>
              </label>
            </td>
            <td style="width: 120px;">
              <span class="status-badge" :class="getCrawlStatusClass(item.crawl_status)">
                {{ $t(crawl_val[item.crawl_status]) }}
              </span>
            </td>
            <td style="width: 100px;">
              <span class="status-badge" :class="getGenerateStatusClass(item.generate_status)">
                {{ $t(generate_val[item.generate_status]) }}
              </span>
            </td>
            <td style="width: 100px;">
              <span class="status-badge" :class="getCheckStatusClass(item.check_status)">
                {{ $t(check_val[item.check_status]) }}
              </span>
            </td>
            <td style="width: 100px;">
              <span class="status-badge" :class="getSendStatusClass(item.send_status)">
                {{ $t(send_val[item.send_status]) }}
              </span>
            </td>
            <td style="width: 150px; white-space: nowrap;">
              {{ item.last_sent_at ? datePipe(item.last_sent_at, 'yyyy/MM/dd hh:mm') : '-' }}
            </td>
            <td style="width: 250px;">
              <button class="btn btn-primary tabel-btn"
                      @click="openEditModal(item.id)">
                {{ $t("SalesListsDetailsView.edit") }}
              </button>
              <button class="btn btn-danger tabel-btn" data-bs-toggle="modal" data-bs-target="#DeleteModal"
                @click.stop="openDeleteModal(item)">
                {{ $t("SalesListsDetailsView.delete") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ページコンポーネント -->
    <div class="mw-25 pagination-fixed-bottom">
      <nav v-if="showPaging" aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item" @click="setFirstPage()">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li class="page-item" @click="previousPage()"><a class="page-link" href="#">&lt;</a></li>
          <li class="page-item" v-for="(page, index) in activePageList" :key="index">
            <a class="page-link" href="#" :class="page == selectedPage ? 'active' : ''"
              @click="setSelectedPage(page)">{{ page }}</a>
          </li>
          <li class="page-item" @click="nextPage()"><a class="page-link" href="#">&gt;</a></li>
          <li class="page-item" @click="setLastPage()">
            <a class="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Send mail modal begin -->
  <button id="send_mail_finished" data-bs-toggle="modal" data-bs-target="#CheckModal" style="display:none;"></button>
  <div class="modal fade" id="CheckModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="d-modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t('SalesListsDetailsView.send_mail_modal_title') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ $t('SalesListsDetailsView.send_mail_modal_text') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" @click="refreshData" class="btn btn-primary" data-bs-dismiss="modal">
            {{ $t('SalesListsDetailsView.OK') }}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Send mail modal end -->

  <!-- Delete confirmation modal begin -->
  <div class="modal fade" id="DeleteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("SalesListsDetailsView.delete") }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          {{ $t("SalesListsDetailsView.company_name") }}: {{ title_for_delete }}
          {{ $t("SalesListsDetailsView.delete_confirm") }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="handleDelete">
            {{ $t("SalesListsDetailsView.OK") }}
          </button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $t("SalesListsDetailsView.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete confirmation modal end -->

  <!-- EditSalesListsDetailsView modal begin -->
  <div class="modal fade" id="editSalesListsDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("SalesListsDetailsView.model_title") }}
          </h5>
          <button type="button" class="btn-close" @click="hideModal('editSalesListsDetails')" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <!--  company_name-->
          <div class="row">
            <label for="company_name" class="form-label">
              {{ $t('SalesListsDetailsView.model_company_name') }} </label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" id="company_name" v-model="detai_item.company_name">
            </div>
          </div>

          <!--  person_name-->
          <div class="row">
            <label for="person_name" class="form-label">
              {{ $t('SalesListsDetailsView.model_person_name') }} </label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" id="person_name" v-model="detai_item.person_name">
            </div>
          </div>

          <!--  company_url-->
          <div class="row">
            <label for="company_url" class="form-label">
              {{ $t('SalesListsDetailsView.model_company_url') }} </label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" id="company_url" v-model="detai_item.company_url">
            </div>
          </div>

          <!--  email-->
          <div class="row">
            <label for="email" class="form-label">
              {{ $t('SalesListsDetailsView.model_email') }} </label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" id="email" v-model="detai_item.email">
            </div>
          </div>

          <!--  company_detail-->
          <div class="row">
            <label for="company_detail" class="form-label">
              {{ $t('SalesListsDetailsView.model_company_detail') }} </label>
            <div class="input-group mb-3">
              <textarea id="company_detail" class="form-control" v-model="detai_item.company_detail"
                rows="8"></textarea>
            </div>
          </div>

          <!--  mail_text-->
          <div class="row">
            <label for="mail_text" class="form-label">
              {{ $t('SalesListsDetailsView.model_mail_text') }} </label>
            <div class="input-group mb-3">
              <textarea id="mail_text" class="form-control" v-model="detai_item.mail_text" rows="20"></textarea>
            </div>
          </div>

          <!--  check_status-->
          <div class="row">
            <div class="column">
              <label for="check_status">
                {{ $t('SalesListsDetailsView.model_check_status') }}
              </label>
              <input class="form-check-input" type="checkbox" id="check_status" v-model="detai_item.check_status" />
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hideModal('editSalesListsDetails')">
            {{ $t("SalesListsDetailsView.cancel") }}
          </button>
          <button type="button" class="btn btn-primary" @click.stop="updateData">
            {{ $t("SalesListsDetailsView.model_update") }}
          </button>
          <button type="button" class="btn btn-success" @click.stop="handleConfirmAndSend" :disabled="isLoading">
            {{ $t('SalesListsDetailsView.confirm_and_send') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- EditSalesListsDetailsView modal end -->

  <!-- Bulk Delete confirmation modal begin -->
  <div v-if="showBulkDeleteModal" class="bulk-delete-modal-overlay">
    <div class="bulk-delete-modal-dialog">
      <div class="bulk-delete-modal-content">
        <div class="bulk-delete-modal-header">
          <h5 class="modal-title">
            {{ $t("SalesListsDetailsView.bulk_delete_confirm_title") }}
          </h5>
          <button type="button" class="bulk-delete-btn-close" @click="cancelBulkDelete" aria-label="Close">&times;</button>
        </div>
        <div class="bulk-delete-modal-body">
          <p>{{ $t("SalesListsDetailsView.bulk_delete_confirm_message", { count: bulkDeleteIds.length }) }}</p>
          <div class="mt-3">
            <strong>削除対象:</strong>
            <ul class="mt-2">
              <li v-for="itemId in bulkDeleteIds.slice(0, 5)" :key="itemId">
                {{ raw_data.find(item => item.id === itemId)?.company_name || `ID: ${itemId}` }}
              </li>
              <li v-if="bulkDeleteIds.length > 5">
                ... 他 {{ bulkDeleteIds.length - 5 }}件
              </li>
            </ul>
          </div>
        </div>
        <div class="bulk-delete-modal-footer">
          <button type="button" class="btn btn-danger" @click="confirmBulkDelete" :disabled="isLoading">
            {{ $t("SalesListsDetailsView.delete") }}
          </button>
          <button type="button" class="btn btn-secondary" @click="cancelBulkDelete">
            {{ $t("SalesListsDetailsView.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Bulk Delete confirmation modal end -->

</template>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196F3;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

.row {
  display: flex;
  margin: 15px 5px;
}

.column {
  flex: 1;
}

.table-cell {
  flex: 1;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 40px 0;
}

.table-header .table-cell {
  font-weight: bold;
  background-color: #f5f5f5;
}

.modal-delete {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  /* 他の要素より前面に */
}

.d-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  /* お好みに合わせて変更 */
  max-width: 500px;
  /* お好みに合わせて変更 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.tabel-btn {
  padding: 0 20px;
  margin: 10px;
}

.fixed-table {
  table-layout: fixed;
  width: 100%;
}

.fixed-table th,
.fixed-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pagination-fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  /* 确保在其他元素之上 */
  text-align: center;
  /* 居中对齐 */
}

.status-tabs {
  display: flex;
  gap: 8px;
  margin: 20px 0;
  justify-content: center;
  flex-wrap: wrap; /* 画面が狭い場合に折り返し */
}

.status-tab {
  padding: 8px 16px; /* パディングを少し小さく */
  border: 2px solid #ddd;
  background-color: #f8f9fa;
  color: #495057;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.9em; /* フォントサイズを少し小さく */
}

.status-tab:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.status-tab.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.status-tab.active:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: 600;
  text-align: center;
  min-width: 60px;
  min-height: 24px;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  vertical-align: middle;
}

/* 処理待ち・送信なし - グレー */
.status-pending {
  background: linear-gradient(135deg, #6c757d, #5a6268);
  border: 1px solid #545b62;
}

/* 処理中・送信中 - 黄色 */
.status-processing {
  background: linear-gradient(135deg, #ffc107, #e0a800);
  color: #212529;
  border: 1px solid #d39e00;
  text-shadow: none;
}

/* 完了・送信完了 - 緑 */
.status-completed {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  border: 1px solid #1c7430;
}

/* 失敗・送信失敗 - 赤 */
.status-failed {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: 1px solid #bd2130;
}

/* 未確認 - オレンジ */
.status-unconfirmed {
  background: linear-gradient(135deg, #fd7e14, #e8590c);
  border: 1px solid #dc5200;
}

/* 確認済み - 青 */
.status-confirmed {
  background: linear-gradient(135deg, #007bff, #0056b3);
  border: 1px solid #004085;
}

/* 配信済み - 濃い緑 */
.status-delivered {
  background: linear-gradient(135deg, #155724, #0d3d1a);
  border: 1px solid #0a2e13;
}

/* 開封済み - 青 */
.status-opened {
  background: linear-gradient(135deg, #17a2b8, #138496);
  border: 1px solid #117a8b;
}

/* クリック済み - 紫 */
.status-clicked {
  background: linear-gradient(135deg, #6f42c1, #5a2d91);
  border: 1px solid #4e2a84;
}

/* ホバー効果 */
.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: all 0.2s ease;
}

/* テーブルセルの垂直中央揃えを追加 */
.fixed-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.fixed-table th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

/* 一括削除モーダル専用のスタイル */
.bulk-delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.bulk-delete-modal-dialog {
  width: 90%;
  max-width: 500px;
}

.bulk-delete-modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.bulk-delete-modal-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bulk-delete-modal-body {
  padding: 1rem;
}

.bulk-delete-modal-footer {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.bulk-delete-btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #000;
  opacity: 0.5;
}

.bulk-delete-btn-close:hover {
  opacity: 0.75;
}

/* 元のmodal関連のCSSを削除 */
</style>